import { render } from "./ui-modal-window.vue?vue&type=template&id=68a4191e&ts=true"
import script from "./ui-modal-window.vue?vue&type=script&lang=ts"
export * from "./ui-modal-window.vue?vue&type=script&lang=ts"

import "./ui-modal-window.vue?vue&type=style&index=0&id=68a4191e&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__